import { createContext } from 'react'

export const initialGlobalContextValue = {
  supportsWebp: true,
  userInfo: {
    id: 0,
    company: '',
    name: '',
    mobile: '',
    accountAmount: 0,
    smsAuth: false
  }
}

export interface IGlobalContext {
  supportsWebp: boolean;
  userInfo: {
    id: number;
    company: string;
    name: string;
    mobile: string;
    accountAmount: number;
    smsAuth: boolean;
  }
}

const GlobalContext = createContext<IGlobalContext>(initialGlobalContextValue)

export default GlobalContext
